module.exports = __webpack_public_path__ + "img/seabrokersGroup-04.48209c0d.png";